<template>
    <persistent-banner
        v-if="show"
        background-color="var(--status-color-map-blue-background)"
        text-color="var(--text-body-default-base)">
        <pendo-icon
            class="install-banner__icon"
            type="alert-circle"
            :size="24" />
        <span class="install-banner__content">
            {{
                $t(
                    "installsnippetBanner.Looks like you haven't installed the Pendo Snippet yet. Once it's installed, you'll see your product data and be able to use Pendo."
                )
            }}
        </span>
        <pendo-button
            class="install-banner__button"
            theme="app"
            type="primary"
            :label="$t('installsnippetBanner.Here\'s how to install it')"
            size="mini"
            @click="goToSetup" />
    </persistent-banner>
</template>

<script>
import { mapGetters } from 'vuex';
import { PendoButton, PendoIcon } from '@pendo/components-vue3';
import PersistentBanner from '../../common/persistent-banner/persistent-banner.vue';
import get from 'lodash/get';

import { mapState as mapPiniaState } from 'pinia';
import { useSubscriptionStore } from '@/stores/subscription.store';
import { useProductLinesStore } from '@/stores/product-lines.store';

export default {
    name: 'InstallSnippetBanner',
    components: {
        PersistentBanner,
        PendoButton,
        PendoIcon,
    },
    computed: {
        ...mapPiniaState(useSubscriptionStore, {
            subscription: (store) => store.active,
        }),

        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated',
            hasOnlyNovusSub: 'auth/hasOnlyNovusSub',
        }),

        ...mapPiniaState(useProductLinesStore, {
            productLineByType: 'productLineByType',
        }),

        ...mapPiniaState(useSubscriptionStore, {
            isInTrial: 'isInTrial',
        }),

        show () {
            if (this.hasOnlyNovusSub) return false;
            if (this.isInTrial) return false;
            if (this.$route && this.$route.name === 'OnboardingHomepage') return false;
            if (!this.isAuthenticated) return false;
            if (this.feedbackOnly) return false;

            return !this.subscription.eventCount;
        },

        feedbackOnly () {
            const feedbackProductLine = this.productLineByType('feedback');
            const coreProductLine = this.productLineByType('core');

            const feedbackPurchased = get(feedbackProductLine, 'purchased', false);
            const corePurchased = get(coreProductLine, 'purchased', false);

            return feedbackPurchased && !corePurchased;
        },
    },
    methods: {
        goToSetup () {
            window.location.assign(`/setup?setupKey=${this.subscription.setupKey}`);
        },
    },
};
</script>

<style scoped lang="less">
.install-banner__icon {
    margin-right: 16px;
}
.install-banner__content {
    text-align: center;
}
.install-banner__button {
    margin-left: 16px;
    font-size: 12px;
    font-weight: 400;
}
</style>
